import loginApi from '@/api/loginApi';
import questionApi from '@/api/questionApi';
import indexApi from '@/api/indexApi';
import categoryApi from "@/api/categoryApi";
import commentApi from "@/api/commentApi";
import suggestionApi from "@/api/suggestionApi"
export default {loginApi, questionApi, indexApi,categoryApi,commentApi,suggestionApi}
